import { render, staticRenderFns } from "./ClassificationDegreeFilter.vue?vue&type=template&id=2b0fed6b&"
import script from "./ClassificationDegreeFilter.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports